import { OVERLAP_ERROR_CODE } from '../../services/workerAssignmentsService';

/** Violation d'un CHECK — ici, end_time > start_time. */
const CHECK_ERROR_CODE = '23514';
/** Refus de la RLS. Postgres le rend en 42501 ; PostgREST y ajoute parfois PGRST301. */
const FORBIDDEN_CODES = ['42501', 'PGRST301'];

/**
 * Le vrai motif d'un echec d'ecriture, en francais.
 *
 * 🔴 « L'enregistrement a echoue » ne dit RIEN. Il a coute dix minutes de
 * diagnostic alors que Postgres avait parfaitement nomme la cause. Chaque code
 * connu recoit donc sa phrase, et l'inconnu garde SON CODE entre parentheses :
 * dix secondes de diagnostic au lieu de dix minutes.
 *
 * @param {Object}   error  l'erreur PostgREST
 * @param {Function} t      la fonction de traduction
 * @param {Object}   ctx    { conflict, worker, projectLabel, dateLabel } si connus
 */
export const assignmentErrorMessage = (error, t, ctx = {}) => {
  const code = error?.code || '';
  const message = error?.message || '';

  if (code === OVERLAP_ERROR_CODE) {
    // Quand on a pu relire la ligne fautive, on la nomme : qui, quand, ou.
    if (ctx?.conflict) {
      return t('teamSchedule.errors.overlapNamed', {
        worker: ctx?.worker || '',
        time: ctx?.time || '',
        project: ctx?.projectLabel || '',
        date: ctx?.dateLabel || '',
      });
    }
    return t('teamSchedule.errors.overlapRace');
  }

  if (code === CHECK_ERROR_CODE) return t('teamSchedule.errors.checkFailed');

  if (FORBIDDEN_CODES?.includes(code) || /row-level security/i?.test(message)) {
    return t('teamSchedule.errors.forbidden');
  }

  // Inconnu : un message court, PLUS le code. Sans le code, on repart a zero.
  return t('teamSchedule.errors.saveFailedCode', { code: code || message?.slice(0, 60) || '?' });
};

export default assignmentErrorMessage;
